module.exports = __webpack_public_path__ + "static/media/clothes_title_ko.ad926fe5.png";